import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from '@app/app.module';
import { environment } from '@env/environment';

if (environment.production)
{
    enableProdMode();
}

setTimeout(() =>
{
    platformBrowserDynamic().bootstrapModule(AppModule)
        .catch(err => console.log(err));
}, 1100);


